const environment = {
  LIVEKIT_BOT_URL: process.env.REACT_APP_LIVEKIT_BOT_URL ,
  LIVEKIT_URL: process.env.REACT_APP_LIVEKIT_URL ,
  LIVEKIT_WSS_URL: process.env.REACT_APP_LIVEKIT_WSS_URL ,
  TYPING_DELAY_BASE: parseInt(process.env.REACT_APP_TYPING_DELAY_BASE) || 500,
  TYPING_DELAY_PER_WORD: parseInt(process.env.REACT_APP_TYPING_DELAY_PER_WORD) || 100,
};

export default environment;
